const hemma = [
    {
        'q': 'Jag sover så mycket som jag behöver',
        'a': 0
    },
    {
        'q': 'Jag trivs i mitt hem',
        'a': 0,
    },
    {
        'q': 'Jag känner mig avspänd hemma',
        'a': 0,
    },
    {
        'q': 'Jag har vardagsrutiner som jag mår bra av',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med hur sysslorna fördelas',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med den ordning jag har hemma',
        'a': 0,
    },
    {
        'q': 'Jag kan koppla bort jobbet när jag behöver',
        'a': 0,
    },
    {
        'q': 'Jag kan vila och återhämta mig hemma',
        'a': 0,
    },
    {
        'q': 'Jag har ork kvar när jag kommer hem',
        'a': 0,
    },
    {
        'q': 'Jag har stunder av egen tid när jag behöver',
        'a': 0,
    },
    {
        'q': 'Jag har bra kontakt med grannar',
        'a': 0,
    },
    {
        'q': 'Jag känner mig trygg i mitt hem',
        'a': 0,
    },
    {
        'q': 'Jag upplever gemenskap hemma',
        'a': 0,
    },
];

export default hemma;